import React from 'react';
import './InactiveOrganization.scss';

export const InactiveOrganization = () => {
    return (
        <div className="inactive-organization-body">
            <div className="inactive-organization-content">
                <div className="inactive-icon">
                    <i className="pi pi-lock" style={{ fontSize: '5rem', color: '#ef4444' }}></i>
                </div>
                <div className="inactive-title">Organization Inactive</div>
                <div className="inactive-detail">
                    This organization has been temporarily deactivated. 
                    Please contact your system administrator for more information.
                </div>
                <div className="inactive-contact">
                    <p>If you believe this is an error, please reach out to support.</p>
                </div>
            </div>
        </div>
    );
};
